<template>
  <BigNumberParent class="aktivanteil" ref="chartcontainer">
    <div
      :style="{
        width: `${sparklineWidth}px`,
        height: `${sparklineHeight + 15 + 4}px`,
        padding: '',
        position: 'absolute',
        bottom: 0,
        left: '0px',
        boxSizing: 'content-box'
      }"
    >
      <svg
        :viewBox="`0 0 ${sparklineWidth} ${sparklineHeight + 15}`"
        v-if="sparklineWidth"
        ref="aktive_svg"
      >
        <rect
          :x="0"
          :y="0"
          :width="activeMaxRectWidth"
          :height="activeMaxRectHeight"
          :fill="colors.davon_max_aktive"
          v-if="aktive_max_texture"
        ></rect>

        <text
          :x="5"
          :y="14 + 2.5"
          :fill="colors.schaetzung_aktive"
          :style="{ fontWeight: 'bold', fontSize: '14px' }"
          v-if="
            aktive_secondmax_texture &&
              activeMaxRectWidth + activeSecondmaxRectWidth < sparklineWidth
          "
        >
          {{
            $fmt(format)(
              this.active_max_latest["bestätigte_Fälle_zweiwochen_diff"]
            )
          }}
        </text>
        <text
          :x="4"
          :y="sparklineHeight + 10 + 5"
          fill="white"
          :style="{ fontSize: '12px' }"
        >
          in {{ this.active_max_latest.land
          }}{{
            this.active_max_latest.bestätigte_Fälle_zweiwochen_diff_quelle ==
            "selbstberechnet"
              ? "⚠️"
              : ""
          }}
        </text>
        <rect
          :x="0 + activeMaxRectWidth"
          :y="0"
          :width="activeSecondmaxRectWidth"
          :height="activeSecondmaxRectHeight"
          :fill="colors.schaetzung_aktive"
          v-if="aktive_secondmax_texture"
        ></rect>
        <text
          :x="activeMaxRectWidth + 4"
          :y="14 + 2.5"
          fill="#3b3a39"
          :style="{ fontWeight: 'bold', fontSize: '14px' }"
        >
          {{
            $fmt(format)(
              this.active_secondmax_latest["bestätigte_Fälle_zweiwochen_diff"]
            )
          }}
        </text>
        <text
          :x="activeMaxRectWidth + 2"
          :y="sparklineHeight + 10 + 5"
          fill="white"
          :style="{ fontSize: '12px' }"
        >
          in {{ this.active_secondmax_latest.land
          }}{{
            this.active_secondmax_latest
              .bestätigte_Fälle_zweiwochen_diff_quelle == "selbstberechnet"
              ? "⚠️"
              : ""
          }}
        </text>

        <rect
          :x="0.5 + activeMaxRectWidth + activeSecondmaxRectWidth"
          :y="0"
          :width="
            sparklineWidth - activeMaxRectWidth - activeSecondmaxRectWidth - 1
          "
          :height="activeSecondmaxRectHeight"
          :fill="aktive_rest_texture.url()"
          v-if="aktive_rest_texture"
        ></rect>
        <rect
          x="1"
          y="1"
          :width="sparklineWidth - 2"
          :height="sparklineHeight"
          :stroke="colors.schaetzung_aktive"
          stroke-width="2"
          fill="transparent"
        ></rect>
        <text
          :x="sparklineWidth"
          :y="sparklineHeight + 10 + 5"
          fill="white"
          text-anchor="end"
          :style="{ fontSize: '12px' }"
        >
          Rest
        </text>
      </svg>
    </div>
    <div class="aktive_faelle" :style="`font-size: 14px;`">
      <div class="dg-value" :style="`color: ${colors.schaetzung_aktive}`">
        {{ $fmt(",d")(austria_latest["bestätigte_Fälle_zweiwochen_diff"]) }}
      </div>
      <h6>
        Schätzung aktive Fälle
        <a href="https://www.corona-ampel.org/methodik/#aktive-f%C3%A4lle">
          <span
            data-tooltip
            title="Wir verwenden die 14-Tage-Fallzahl zur Schätzung der aktiven Fälle, da die AGES nicht vergleichbare Zahlen zu Genesenen publiziert"
            >⚠️</span
          >
        </a>
      </h6>
    </div>
    <div class="outlier-right">
      <h6>gestern</h6>
      <div>
        <span
          class="dg-value2"
          :style="{ color: this.colors.schaetzung_aktive }"
          >{{ $fmt("+,d")(this.oesterreich_gesternheute.diff_14d) }}</span
        >
      </div>
    </div>
  </BigNumberParent>
</template>
<script>
import BigNumberParent from "./BigNumberParent.vue";
import ComponentSizeMixin from "./ComponentSizeMixin";
import textures from "textures";
import * as selection from "d3-selection";

export default {
  name: "BigNumberAktivAnteilig",
  components: {
    BigNumberParent
  },
  mixins: [ComponentSizeMixin],
  props: {
    bundeslaender_timeline: Array,
    active_max_latest: Object,
    active_secondmax_latest: Object,
    colors: Object,
    sparkline: Array,
    sparkline_keys: Array,
    mobile: String,
    format: {
      type: String,
      default: ",.0f"
    },
    bestaetigte_faelle_summe_aenderung: Array
  },
  data() {
    return {
      aktive_max_texture: null,
      aktive_secondmax_texture: null,
      aktive_rest_texture: null
    };
  },
  mounted() {
    if (window.$) {
      window.$("[data-tooltip]").foundation();
    }
  },
  updated() {
    if (this.$refs.aktive_svg && this.aktive_max_texture === null) {
      this.aktive_max_texture = textures
        .lines()
        .thicker(2.5)
        .lighter()
        .orientation("6/8")
        .background(this.colors.davon_max_aktive)
        .stroke(this.colors.schaetzung_aktive);

      this.aktive_rest_texture = textures
        .lines()
        .orientation("2/8")
        .thicker(2.5)
        .lighter()
        .stroke(this.colors.schaetzung_aktive);

      this.aktive_secondmax_texture = textures
        .lines()
        .orientation("2/8")
        .thicker(2.5)
        //.lighter()
        .stroke(this.colors.schaetzung_aktive);

      selection.select(this.$refs.aktive_svg).call(this.aktive_max_texture);
      selection
        .select(this.$refs.aktive_svg)
        .call(this.aktive_secondmax_texture);
      selection.select(this.$refs.aktive_svg).call(this.aktive_rest_texture);
    }
    if (window.$) {
      window.$("[data-tooltip]").foundation();
    }
  },
  methods: {},
  computed: {
    austria_latest() {
      return this.bundeslaender_timeline
        .filter(d => d.land == "Österreich")
        .reverse()[0];
    },
    sparklineWidth() {
      if (!this.chartcontainerWidth) {
        return null;
      }
      return this.chartcontainerWidth;
    },
    sparklineHeight() {
      return 21;
    },
    sparklineArea() {
      return this.sparklineWidth * this.sparklineHeight;
    },
    sparklinePixelPerCase() {
      return (
        this.sparklineArea /
        this.austria_latest["bestätigte_Fälle_zweiwochen_diff"]
      );
    },
    activeMaxRectArea() {
      return (
        this.active_max_latest["bestätigte_Fälle_zweiwochen_diff"] *
        this.sparklinePixelPerCase
      );
    },
    activeMaxRectHeight() {
      return this.sparklineHeight;
    },
    activeMaxRectWidth() {
      return Math.round(this.activeMaxRectArea / this.activeMaxRectHeight);
    },
    activeSecondmaxRectArea() {
      return (
        this.active_secondmax_latest["bestätigte_Fälle_zweiwochen_diff"] *
        this.sparklinePixelPerCase
      );
    },
    activeSecondmaxRectHeight() {
      return this.sparklineHeight;
    },
    activeSecondmaxRectWidth() {
      return Math.round(
        this.activeSecondmaxRectArea / this.activeSecondmaxRectHeight
      );
    },
    oesterreich_gesternheute() {
      return this.bestaetigte_faelle_summe_aenderung.filter(
        d => d.bezcode == "000"
      )[0];
    }
  },
  provide() {
    return {
      getTooltipEl: function() {
        return this.$refs.sparklineTooltip;
      }.bind(this)
    };
  }
};
</script>

<style scoped>
.bignumber {
  min-height: 80px;
}

.flex-row.bna {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  position: relative;
  pointer-events: none;

  font-variant-numeric: tabular-nums; /* high-level property          */
  -moz-font-feature-settings: "tnum"; /* low-level (old Firefox)      */
  -webkit-font-feature-settings: "tnum"; /* low-level (old Webkit)       */
  font-feature-settings: "tnum" on; /* low-level (all new browsers) */
}

.flex-row >>> .sparkline-wrap {
  display: inline-block;
  width: 33%;
  text-align: right;
}

.flex-right {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding-top: 0px;
  text-align: right;
  align-items: flex-end;
}

table {
  padding-bottom: 15px;
  display: table-cell;
  border-collapse: collapse;
}

.dg-value {
  font-size: 26px;
  line-height: 1em;
  font-weight: bold;
}

h6 {
  font-size: 14px;
  margin: 0;
  display: block;
  color: white;
  text-align: left;
  padding-left: 3px;
  font-weight: normal;
  padding-bottom: 2px;
}

.aktive_faelle h6 {
  text-align: left;
  line-height: 16px;
}

td,
th,
tr {
  vertical-align: baseline;
  line-height: 1;
}

th {
  font-size: 10px;
  font-weight: normal;
  color: white;
  padding: 0px 4px;
}

td.diff {
  width: auto;
  text-align: left;
  font-size: 10px;
  font-weight: normal;
}

.bgspan {
  background: rgba(59, 58, 57, 0);
  border-radius: 3px;
  padding-left: 2px;
  padding-right: 2px;
}

.dg-value.value2 {
  font-size: 14px;
}

.dg-value2 {
  font-size: 20px;
  font-weight: bold;
  line-height: 0.6em;
  display: inline-block;
}

@media (min-width: 700px) {
  .cmc_normal .dg-value {
    font-size: 32px;
  }
  .cmc_normal .dg-value.value2 {
    font-size: 16px;
  }
}

@media (min-width: 900px) {
  .cmc_normal .dg-value {
    font-size: 36px;
  }

  .cmc_normal .dg-value.value2 {
    font-size: 18px;
  }
  .cmc_normal .dg-value2 {
    font-size: 22px;
  }

  .cmc_normal td.diff,
  .cmc_normal th {
    font-size: 12px;
  }
}

.sparklineTooltip {
  font-size: 10px;
  right: 10px;
}

.aktive_faelle,
.outlier-right {
  position: absolute;
  top: 6px;
}
.aktive_faelle {
  left: 6px;
}
.outlier-right {
  right: 6px;
}

.outlier-right {
  position: absolute;
  top: 12px;
  display: flex;
  flex-direction: column;
  text-align: right;
  justify-content: center;
  margin-top: 0.1em;
}

@media (min-width: 700px) {
  .aktive_faelle,
  .outlier-right {
    top: 0.7em;
  }
  .aktive_faelle {
    left: 0.7em;
  }
  .outlier-right {
    right: 0.7em;
    margin-top: 0.7em;
  }
}

@media (min-width: 900px) {
  .aktive_faelle,
  .outlier-right {
    top: 1.1em;
  }
  .aktive_faelle {
    left: 1.1em;
  }
  .outlier-right {
    right: 1.1em;
    margin-top: 0.8em;
  }
}
</style>
